const TAMANHO_SEM_DV = 12;
const REGEX_CNPJ = /^[A-Z\d]{12}(\d){2}$/;
const REGEX_CARACTERES_NAO_PERMITIDOS = /[^A-Z\d./-]/i;
const REGEX_MASCARA = /[./-]/g;
const VALOR_BASE = '0'.charCodeAt(0);
const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_ZERADO = '00000000000000';

function removeMascara(cnpj) {
  return cnpj.replace(REGEX_MASCARA, '');
}

function calculaDV(base) {
  let somatorioDV1 = 0;
  let somatorioDV2 = 0;

  for (let i = 0; i < TAMANHO_SEM_DV; i += 1) {
    const valor = base.charCodeAt(i) - VALOR_BASE;
    somatorioDV1 += valor * PESOS_DV[i + 1];
    somatorioDV2 += valor * PESOS_DV[i];
  }

  const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
  somatorioDV2 += dv1 * PESOS_DV[TAMANHO_SEM_DV];
  const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

  return `${dv1}${dv2}`;
}

export default function validaCnpj(cnpj) {
  if (!cnpj || REGEX_CARACTERES_NAO_PERMITIDOS.test(cnpj)) return false;

  const limpo = removeMascara(cnpj.toUpperCase());
  if (!REGEX_CNPJ.test(limpo) || limpo === CNPJ_ZERADO) return false;

  const dvInformado = limpo.substring(TAMANHO_SEM_DV);
  const dvCalculado = calculaDV(limpo.substring(0, TAMANHO_SEM_DV));

  return dvInformado === dvCalculado;
}
